var _rect, _rect2, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSubscriptionsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 263,
    viewBox: "0 0 218 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 263,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1436,
    height: 1117,
    transform: "translate(-676 -2946)",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -533,
    y: -225,
    width: 1260,
    height: 586,
    rx: 16,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.736 6.47461H28.4889C14.9266 6.47461 3.93213 16.5308 3.93213 28.9357V227.668C3.93213 240.073 14.9266 250.129 28.4889 250.129H188.736C202.298 250.129 213.293 240.073 213.293 227.668V28.9357C213.293 16.5308 202.298 6.47461 188.736 6.47461Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.443 0H24.5567C10.9944 0 0 10.075 0 22.5031V240.497C0 252.925 10.9944 263 24.5567 263H193.443C207.006 263 218 252.925 218 240.497V22.5031C218 10.075 207.006 0 193.443 0Z",
    fill: "#E3E8EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.873 187H75.1273C72.2956 187 70 189.239 70 192C70 194.761 72.2956 197 75.1273 197H142.873C145.704 197 148 194.761 148 192C148 189.239 145.704 187 142.873 187Z",
    fill: "#83FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.822 211H49.1784C46.3184 211 44 213.239 44 216C44 218.761 46.3184 221 49.1784 221H168.822C171.682 221 174 218.761 174 216C174 213.239 171.682 211 168.822 211Z",
    fill: "#83FF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.814 228H57.186C54.3219 228 52 230.239 52 233C52 235.761 54.3219 238 57.186 238H160.814C163.678 238 166 235.761 166 233C166 230.239 163.678 228 160.814 228Z",
    fill: "#83FF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 151C81.0768 148.456 72.8705 144.148 65.9543 138.38C59.0406 132.612 53.5852 125.523 49.9735 117.612C46.3617 109.701 44.6815 101.16 45.0497 92.5889C45.418 84.0177 47.8274 75.6248 52.1073 68",
    stroke: "#FFC147",
    strokeWidth: 10.6338,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74.4436C54.3129 61.7544 64.3745 51.1534 77.4309 44.4855C90.4897 37.8173 105.718 35.5044 120.464 37.9491C135.211 40.3939 148.546 47.4415 158.143 57.8656C167.743 68.2895 173 81.43 173 95",
    stroke: "#1B6600",
    strokeWidth: 10.6338,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173 95C173 105.431 169.89 115.669 163.994 124.635C158.101 133.602 149.64 140.965 139.507 145.949C129.371 150.934 117.937 153.355 106.41 152.958C94.8828 152.561 83.6858 149.36 74 143.693",
    stroke: "#04C017",
    strokeWidth: 10.6338,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -537,
    y: -225,
    width: 1268,
    height: 594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -33.4139,
    y: -16.1896,
    width: 284.053,
    height: 318.346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.6818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.673
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.124574 0 0 0 0 0.141235 0 0 0 0 0.541097 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubscriptionsImage);
export default __webpack_public_path__ + "static/media/no_subscriptions_image.183569ff2bc248b2ad09dd8adffec138.svg";
export { ForwardRef as ReactComponent };